module.exports = __webpack_public_path__ + "static/media/Dans_Web.cc8ffb7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Commercial/Dans_Web.jpg
// module id = 124
// module chunks = 0